export const isDisabled = (rights, linkTitle) => {
  const agentRights = Array.isArray(rights)
    ? rights[0] || {} // use the first object if available
    : rights || {}; // fallback to empty object if null/undefined

  switch (linkTitle) {
    //Properties
    case "Agency Properties":
      return !agentRights.viewProperty;
    case "Add Property":
      return !agentRights.addProperty;
    case "Update Property":
      return !agentRights.updateProperty;
    case "Property Location":
      return !agentRights.propertylocation;
    case "Owner Contact":
      return !agentRights.ownercontact;

    //staff
    case "Add Staff":
      return !agentRights.addstaff;

    //tasks
    case "All Tasks":
      return !agentRights.viewalltask;
    case "Assign Task":
      return !agentRights.assigntask;
    case "Assign Lead":
      return !agentRights.assignlead;

    //Leads
    case "Leads":
      return !agentRights.viewlead;
    case "View Agency Leads":
      return !agentRights.viewalllead;
    case "Add Lead":
      return !agentRights.addLead;
    case "Pool":
      return !agentRights.viewpool;
    case "Upload Leads":
      return !agentRights.uploadleads;
    case "Update Lead":
      return !agentRights.updateLead;
    case "Assign Lead":
      return !agentRights.assignlead;

    //Contacts
    case "Contacts":
      return !agentRights.viewContacts;

    //Today Leads
    case "Today Leads":
      return !true;

    //Accounts
    case "Deals":
      return !agentRights.viewAccounts;
    case "Generate Voucher":
      return !agentRights.genVoucher;

    case "Sales Target":
      return !agentRights.salesTarget;
    case "Generate Lead":
      return !agentRights.genLead;

    default:
      return false;
  }
};

export const hasPermission = (agentRights, requiredPermission) => {
  // Handle case where agentRights is an array
  const rights = Array.isArray(agentRights)
    ? agentRights[0] || {} // use the first object if available
    : agentRights || {}; // fallback to empty object if null/undefined

  switch (requiredPermission) {
    case "addProperty":
      return rights.addProperty;
    case "viewAgencyProperty":
      return rights.viewProperty;
    case "updateProperty":
      return rights.updateProperty;
    case "addLead":
      return rights.addLead;
    case "updateLead":
      return rights.updateLead;
    case "genLead":
      return rights.genLead;
    case "genVoucher":
      return rights.genVoucher;
    case "viewContacts":
      return rights.viewContacts;
    case "todayleads":
      return true;
    case "viewAccounts":
      return rights.viewAccounts;
    case "salesTarget":
      return rights.salesTarget;
    case "assigntask":
      return rights.assigntask;
    case "assignlead":
      return rights.assignlead;
    case "viewlead":
      return rights.viewlead;
    case "viewalllead":
      return rights.viewalllead;
    case "uploadleads":
      return rights.uploadleads;
    case "addstaff":
      return rights.addstaff;
    case "viewpool":
      return rights.viewpool;
    case "viewalltask":
      return rights.viewalltask;
    default:
      return false;
  }
};
